import React, { Component } from 'react'
import Store from './store'
import { observer } from 'mobx-react'
@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }
  componentDidMount() {
    this.store.init()
  }
  render() {
    const { gotoSuperCase, poster } = this.store
    return poster && poster.image_path ? (
      <div
        style={{
          marginLeft: 'auto',
          cursor: 'pointer',
          position: 'fixed',
          top: '39%',
          right: '60px',
          width: 260,
          height: 260
        }}
        onClick={gotoSuperCase}
      >
        <img
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          src={poster.image_path}
        />
      </div>
    ) : null
  }
}
